// extracted by mini-css-extract-plugin
export default {"venueName":"AppointmentBasket-module_venueName_fab1a0"};